// removed by extract-text-webpack-plugin
module.exports = {"memberModerationReferences":"References__memberModerationReferences___2TBKU","references":"References__references___3VyGt"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/admin/memberApprovedProfile/profile/components/references/References.scss
// module id = 1566
// module chunks = 0